import { React, FelaComponent } from '../dependencies';

const rule = ({ theme }) => ({
    margin: '0',
    textAlign: 'center',
    fontFamily: theme.fonts.heading,
    fontSize: '40px',
    fontWeight: '400',

    '@media (max-width: 576px)': {
        fontSize: '30px',
    },
});

const Title = () => {
    return <FelaComponent rule={rule} render={({ className }) => <h1 className={className}>Restaurants</h1>} />;
};

export default Title;
